module.exports = __webpack_public_path__ + "img/Protractor-02.8c36f560.png";